import React from "react";
import Breadcrumbs from "../components/Breadcrumbs";

const PrivacyPolicy: React.FC = () => {
  // Breadcrumb data
  const breadcrumbItems = [
    {
      label: "Privacy Policy",
      path: "/privacy-policy",
    },
  ];

  return (
    <div className="flex flex-col">
      <main className="flex-grow">
        {/* Breadcrumbs */}
        <Breadcrumbs items={breadcrumbItems} />

        {/* Privacy Policy Content */}
        <div className="w-full pt-[15px] pb-[86px] bg-white">
          <div className="px-5 max-w-[1710px] mx-auto">
            <div className="space-y-[32px] text-[#777] font-normal leading-[1.4] text-[13px]">
              <div>
                <h3 className="text-[17px] font-semibold leading-[1.1] mt-[18px] mb-[9px]">
                  Privacy Policy
                </h3>
                <p>
                  At PPE.us L.L.C., we respect your privacy with the highest
                  regards. To this effect, we have implemented the following
                  Privacy Policy. Use of the PPE.us website implies your consent
                  to the Privacy Policy, so please take a moment to review the
                  policy details below:
                </p>
              </div>

              <div>
                <h3 className="text-[17px] font-semibold leading-[1.1] mt-[18px] mb-[9px]">
                  What Personal Information We Collect
                </h3>
                <p>
                  We collect personal information which you provide while using
                  the PPE.us website. This information includes your first and
                  last name, email address and a password of your choosing when
                  you create an PPE.us account. You do not need to set up an
                  account in order to browse the site; however, you will be
                  required to provide this information when placing an order. We
                  may ask you to confirm this personal information when you call
                  our Customer Service department; this allows us to protect
                  your confidentiality by verifying your identity. This
                  information is not shared with or sold to outside parties.
                </p>
              </div>

              <div>
                <h3 className="text-[17px] font-semibold leading-[1.1] mt-[18px] mb-[9px]">
                  Purchase Information
                </h3>
                <p>
                  When placing an order with PPE.us, we collect your name and
                  payment method details. We collect this information in order
                  to charge you for your purchase. We also collect shipping
                  information, including the name, address and telephone number
                  of the recipient(s). All personal information, including your
                  credit card information, is processed via our secure server
                  and is not kept on file for any reason. We use Secure Sockets
                  Layer (SSL) encryption to protect sensitive data when it is
                  transferred over the internet.
                </p>
              </div>

              <div>
                <h3 className="text-[17px] font-semibold leading-[1.1] mt-[18px] mb-[9px]">
                  Cookies and Other Computer Information
                </h3>
                <p>
                  When you visit PPE.us, you will be assigned a permanent
                  "cookie" (a small text file) that is stored on your computer's
                  hard drive. The cookie identifies you when you visit the site
                  so that we can customize and enhance your shopping experience.
                  You may choose to browse our site without cookies; however,
                  without these identifiers you will not be able to complete a
                  purchase or take advantage of certain features of the site. To
                  change your cookie preferences, please check your browser's
                  "Help" menu.
                </p>
                <p className="mt-2">
                  We also collect certain technical data from your computer each
                  time you request a page during your visit to PPE.us. This
                  information may include your IP (Internet Protocol) address,
                  your computer's operating system, browser type, and the
                  address of a referring website, if any. We collect this
                  information to enhance the quality of your experience during
                  your visit and we will not sell or rent this information to
                  any third parties.
                </p>
              </div>

              <div>
                <h3 className="text-[17px] font-semibold leading-[1.1] mt-[18px] mb-[9px]">
                  How We Use Your Personal Information
                </h3>
                <p className="mb-4">
                  The personal information that PPE.us collects from you may be
                  used to:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Verify your identity</li>
                  <li>
                    Provide you information regarding PPE.us products and
                    services.
                  </li>
                  <li>
                    Process your purchases of PPE.us products and services.
                  </li>
                  <li>
                    Coordinate with third party manufacturers, vendors,
                    distributors, delivery services and other third parties in
                    the design, production, distribution and delivery of
                    products and services you purchase from PPE.us.
                  </li>
                  <li>
                    Communicate with you regarding your orders and purchases,
                    and to provide customer service to you.
                  </li>
                  <li>
                    Send you important notices and communications, including
                    those relating to changes to our terms, conditions and
                    policies.
                  </li>
                  <li>
                    Create, develop, operate, deliver and improve our products,
                    services, content and advertising, and for loss prevention
                    and anti-fraud purposes.
                  </li>
                  <li>
                    Conduct internal auditing, data analysis and research to
                    improve PPE.us products and services.
                  </li>
                  <li>
                    Administer and fulfill any sweepstakes, contests or
                    promotions offered by PPE.us that you may enter or
                    participate in.
                  </li>
                  <li>
                    Provide marketing emails and other communications to you
                    from PPE.us (other than those described above) regarding our
                    products, services, sales and special offers (collectively,
                    "Marketing Communications").
                  </li>
                </ul>
              </div>

              <div>
                <h3 className="text-[17px] font-semibold leading-[1.1] mt-[18px] mb-[9px]">
                  How You Can Decide Which Marketing Communications You Receive
                  From Us
                </h3>
                <p>
                  While you may not stop or Opt-Out from receiving the
                  communications described above other than Marketing
                  Communications, if you wish to no longer receive any Marketing
                  Communications at any time i.e, Opt-Out, simply utilize the
                  "unsubscribe" link in any Marketing Communications which you
                  receive. Please allow up to 14 days for us to process your
                  request.
                </p>
              </div>

              <div>
                <h3 className="text-[17px] font-semibold leading-[1.1] mt-[18px] mb-[9px]">
                  More About Your Privacy
                </h3>
                <p>
                  Making an online purchase at PPE.us requires trust on the part
                  of our customers, and we value that trust. We promise that we
                  will work to protect the privacy and security of any personal
                  information you provide us with and that this information will
                  only be used in the ways set forth in this policy. This
                  includes your name, address, phone number, email address,
                  credit card information, and any other personally identifiable
                  information.
                </p>
                <p className="mt-2">
                  We reserve the right to change, modify, or amend this policy
                  at any time. Please review our Privacy Policy periodically for
                  any changes. Use of this website after any modification
                  implies your consent to this Policy as modified.
                </p>
                <p className="my-2">
                  If you have any questions about our privacy policy, or do not
                  wish to enter information online, please feel free to use our
                  phone-in ordering process. Just call 1-888-994-7766, M-F:
                  8AM-6PM CST. A customer service representative will be glad to
                  assist you in completing your order.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PrivacyPolicy;
